import React, {Dispatch, SetStateAction, useState} from 'react';
import s from './BugReport.module.css'
import MyTextarea from "../ui/MyTextarea/MyTextarea";
import MyBtn from "../ui/MyBtn/MyBtn";
import TransparentButton from "../ui/TransparentButton/TransparentButton";
import info from "../../assets/img/personalAccount/info-circle.svg"
import Icon from "@ant-design/icons";
import attachedDoc from "../../assets/img/personalAccount/document.svg";
import delete_document from "../../assets/img/personalAccount/delete_doc.svg";
import {ReactComponent as Plus} from "../../assets/img/personalAccount/plus.svg";
import classnames from "classnames";
import invoice from "../../assets/img/personalAccount/invoice.svg";

type bugReportPropsType = {
    setIsModalOpen: Dispatch<SetStateAction<boolean | null>>;
    setDocumentErrorModalText: Dispatch<SetStateAction<string | null>>;
    setIsDocumentErrorModalOpen: Dispatch<SetStateAction<boolean | null>>;
}

interface FileItem {
    file: File;
}

interface SendUserData {
    file_array: FileItem[];
    message: string
}

const BugReport = (props: bugReportPropsType) => {
    const TEN_MEGABYTES_IN_BYTES = 10485760

    const filesExtension = [
        "image/jpeg",
        "text/plain",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/pdf",
        "application/msword",
    ]

    const [sendUserData, setSendUserData] = useState<SendUserData>({
        message: '',
        file_array: []
    })

    const handleDrop = (e: React.ChangeEvent<HTMLInputElement>) => {
        let file = e.target.files?.[0]
        e.preventDefault()

        if (!file) {
            return;
        }

        let filesArr: FileItem[];

        if (sendUserData.file_array.length <= 0) {
            filesArr = []
        } else {
            filesArr = sendUserData.file_array
        }

        if (file.size > TEN_MEGABYTES_IN_BYTES) {
            props.setDocumentErrorModalText("Large file size!")
            props.setIsDocumentErrorModalOpen(true)
            return
        } else if (!filesExtension.includes(file.type)) {
            props.setDocumentErrorModalText("Invalid file format!")
            props.setIsDocumentErrorModalOpen(true)
            return
        } else if (filesArr.length > 9) {
            props.setDocumentErrorModalText("The number of files is more than 10!")
            props.setIsDocumentErrorModalOpen(true)
            return
        }
        console.log("Good")
        filesArr.push({file})
        props.setDocumentErrorModalText("")

        console.log(filesArr)

        return setSendUserData({...sendUserData, file_array: filesArr})

    }

    const removeDoc = (itemName: string) => {
        const FilteredArr = sendUserData.file_array.filter((file: FileItem) => file.file.name !== itemName)
        setSendUserData({...sendUserData, file_array: FilteredArr})
    }

    return (
        <div className={s.bug_report_wrapper}>
            <div className={s.header}>
                <div>
                    <img src={info} alt=""/>
                </div>
                <div className={s.title}>
                    Report
                </div>
            </div>

            <div className={s.textarea}>
                <MyTextarea style={{height: '100%'}} placeholder={"Enter something"}/>
            </div>

            <div className={s.docs_wrapper}>
                <div className={classnames(s.row_doc, s.flex_start)}>
                    <div className={s.invoice_img}>
                        <img src={invoice} alt=""/>
                    </div>
                    <div>
                        <p className={s.doc_title}>Add supporting document (optional)</p>
                        <p className={s.invoice_desc_format}>Appropriate format: JPEG, JPG, PNG, TXT, PDF.</p>
                    </div>
                </div>

                <div className={s.attached_file_wrapper}>
                    <div className={s.button_wrapper}>
                        <TransparentButton
                            isPersonalAccountBtn
                            title={"Add file"}
                            small
                            icon={<Icon component={() => <Plus/>} rev={undefined}/>}
                            onClick={(e) => {
                                e.preventDefault()
                                // @ts-ignore
                                document.getElementById('hiddenInvoice').click()
                            }}
                        />
                        <input type="file"
                               accept=".png, .jpg, .jpeg, .pdf, .txt"
                               id={"hiddenInvoice"}
                               className={s.hidden_input}
                               onChange={(event) => {
                                   // @ts-ignore
                                   handleDrop(event);
                               }}
                        />
                    </div>
                </div>
            </div>

            <div className={s.attached_file_wrapper}>
                {
                    Array.isArray(sendUserData.file_array) ? sendUserData.file_array.map((item: FileItem, index) => {
                        return (<div key={index} className={s.attached_file}>
                            {
                                <img src={attachedDoc} alt=""/>
                            }
                            {
                                <span className={s.doc_name}>{item.file.name}</span>
                            }
                            {
                                item.file.name &&
                                <img onClick={() => {
                                    removeDoc(item?.file?.name)
                                }}
                                     className={s.delete_doc}
                                     src={delete_document}
                                     alt=""
                                />
                            }
                        </div>)
                    }) : <></>
                }
            </div>

            <div className={s.buttons_wrapper}>
                <TransparentButton
                    title={"Cancel"}
                    isPersonalAccountBtn
                    onClick={() => props.setIsModalOpen(false)}
                    buttonType={"info"}
                    medium
                />
                <MyBtn title={"Send"} isPersonalAccountBtn buttonType="info"/>
            </div>


        </div>
    );
};

export default BugReport;
